import '../node_modules/bootstrap/scss/bootstrap.scss' 


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

function App() {
  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-2">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white pb-5 t-76 title-shade ">Vivienda, Edificación y Productividad</h3>    
                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center ">

                      <Link to="/productos/vivienda/duramax" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Duramax <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/desmoldetemprano" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Desmolde temprano <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/infomix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Infomix <span className="chevron">></span></p>
                      </div>
                      </Link>


                      <Link to="/productos/vivienda/wallmix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Wallmix  <span className="chevron">></span></p>
                      </div>
                      </Link>
                      
                    </div>                    

                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/vivienda/fluidia" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Fluidia/Fluimix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/fluido" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Fluido <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/freezermix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Freezermix  <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/resistenciatemprana" relative="path">
                        <div className="product-block-vivienda d-flex flex-column">
                          <p className="product-block-vivienda-text text-center">Resistencia Temprana <span className="chevron">></span></p>
                        </div>
                      </Link>                       
                      
                    </div>                    

                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/vivienda/hormigonperlado" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigon liviano <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/hormigontiempoviaje" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigón con tiempo de viaje <span className="chevron">></span></p>
                      </div>
                      </Link>


                      <Link to="/productos/vivienda/hormigontiempoespera" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigón con tiempo de espera <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/hormigonseco" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigón seco <span className="chevron">></span></p>
                      </div>
                      </Link>
                      
                    </div>                    

                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/vivienda/losamix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Losamix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/losamixhac" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Losamix HAC <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/hormigon13" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigon 13mm <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/pegamix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Pegamix <span className="chevron">></span></p>
                      </div>
                      </Link>
                      
                    </div>                    

                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/vivienda/hrc" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">HRC <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/vivienda/rdc" relative="path">
                        <div className="product-block-vivienda d-flex flex-column">
                          <p className="product-block-vivienda-text text-center">RDC <span className="chevron">></span></p>
                        </div>
                      </Link>

                     

                      
                    </div>                    

                  </div>                   


                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
